import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import "../../assets/css/MovieList.css";

const SectionHome = () => {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="my-5"></div>
            <div className="mt-4 mb-3 ml-2">
              <div className="mt-5 border-bottom">
                <h2 className="pb-5 text-center">NEW RELEASE</h2>
              </div>
            </div>
            <MovieList />
          </div>
        </div>
      </div>
    </div>
  );
};

const MovieList = () => {
  const [movies, setMovies] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/movies/getMovies`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((result) => {
        // Ensure result.data.results is an array, fallback to an empty array if not
        setMovies(result.movies);
      })
      .catch((error) => {
        console.log(error);
        setMovies([]); // Set to an empty array in case of error
      });
  }, []);

  const movieElements = movies.slice(0, 3).map((movie, index) => (
    <div className="col-md-4 my-5" key={index}>
      <div className="card movie-card position-relative">
        <img src={movie.image} className="card-img-top" alt={movie.title} />
        <div className="card-body">
          <h5 className="card-title">{movie.title}</h5>
          <h6 className="card-subtitle mb-2 text-muted">{movie.genre}</h6>
          <h6 className="card-subtitle mb-2 text-muted">
            Release: {movie.year}
          </h6>
        </div>
        <div className="card-hover position-absolute w-100 h-100">
          <Button
            variant="none"
            className="text-white w-100 h-100"
            style={{ top: 0, left: 0 }}
          >
            View Details
          </Button>
        </div>
      </div>
    </div>
  ));

  return <div className="row">{movieElements}</div>;
};

export default SectionHome;
